import React, { Component } from 'react'
import axios from 'axios'
import Button from '../Design/Button'
import InputButton from '../Design/InputButton'
import { backendUrl } from '../../Services/backend-url'

export default class BillsForm extends Component {
  state = {
    desc: '',
    dueDate: '',
    amount: '',
    username: this.props.username,
  }

  handleDescChange = e => {
    this.setState({ desc: e.target.value })
  }

  handleDueDateChange = e => {
    this.setState({ dueDate: e.target.value })
  }

  handleAmountChange = e => {
    this.setState({ amount: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()
    axios.post(backendUrl + 'bills/new', this.state)
      .then(res => this.setState({
        desc: '',
        dueDate: '',
        amount: '',
      }))
  }

  handleNext = e => {
    this.props.nextStep()
  }

  render() {
    return (
      <div className='fade-in account-info-form font150 roboto'>
        <form className='flex flex-column' onSubmit={this.handleSubmit}>
          <h3 className='fw500 mb'>Add Bills</h3>
          <label className='font75' htmlFor='desc'>Description: </label>
          <input className='font100 text-center mb input-2' type='text' id='desc' name='desc' value={this.state.desc} onChange={this.handleDescChange} placeholder='Netflix'/>
          <label className='font75' htmlFor='dueDate'>Due Date: </label>
          <input className='font100 text-center mb input-2' type='text' id='dueDate' name='dueDate' value={this.state.dueDate} onChange={this.handleDueDateChange} placeholder='mm/dd/year' />
          <label className='font75' htmlFor='amount'>Amount: </label>
          <input className='font100 text-center mb input-2' type='text' id='amount' name='amount' value={this.state.amount} onChange={this.handleAmountChange} placeholder='$13' />
          <InputButton addClass='button-1 font75 mb mt' inputType='submit' text='Add Bill' />
        </form>
        <Button addClass='button-1 font75 mb mt' clicked={this.handleNext} text='Move On To Expenses' />
      </div>
    )
  }
}
